import { useEffect, useContext, useRef } from 'react';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { useLocation } from 'react-router-dom';

import { useWebsite } from '../contexts/WebsiteContext';
import { AuthContext } from '../contexts/AuthContext';
import config from '../config/config';

const VisitTracker = () => {
    const { isLoggedIn } = useContext(AuthContext);
    const { website } = useWebsite();
    const location = useLocation();
    const previousPageRef = useRef(null); // stocke la page précédente

    useEffect(() => {
        const getSupport = () => {
            const userAgent = navigator.userAgent.toLowerCase();
            if (userAgent.match(/mobile/i)) return "MOBILE";
            else if (userAgent.match(/tablet/i)) return "TABLET";
            else return "DESKTOP";
        };

        const getSource = () => {
            const referrer = document.referrer;
            if (!referrer) return "DIRECT";
            else if (referrer.includes("google")) return "GOOGLE";
            else if (referrer.includes("bing")) return "BING";
            else if (referrer.includes("yahoo")) return "YAHOO";
            else if (referrer.includes("facebook")) return "FACEBOOK";
            else if (referrer.includes("twitter")) return "TWITTER";
            else if (referrer.includes("youtube")) return "YOUTUBE";
            else if (referrer.includes("instagram")) return "INSTAGRAM";
            else if (referrer.includes("wikipedia")) return "WIKIPEDIA";
            else if (referrer.includes("tripadvisor")) return "TRIP_ADVISOR";
            else return "OTHER";
        };

        const trackVisit = async () => {
            const currentPage = location.pathname;
            const previousPage = previousPageRef.current || '';

            let uuid = localStorage.getItem('visitorUuid');
            if (!uuid) {
                uuid = uuidv4();
                localStorage.setItem('visitorUuid', uuid);
            }

            let acquisitionSource = localStorage.getItem('acquisitionSource');
            if (!acquisitionSource) {
                acquisitionSource = getSource();
                localStorage.setItem('acquisitionSource', acquisitionSource);
            }

            let support = localStorage.getItem('support');
            if (!support) {
                support = getSupport();
                localStorage.setItem('support', support);
            }

            const formData = {
                website,
                page: currentPage,
                previousPage,
                support,
                source: acquisitionSource,
                isLoggedIn,
                visitorUuid: uuid,
            };

            try {
                await axios.post(`${config.apiUrl}visit`, formData);
            } catch (error) {
                // console.log('Visit tracking failed:', error);
            }

            previousPageRef.current = currentPage;
        };

        trackVisit();
    }, [location, isLoggedIn, website]);

    return null;
};

export default VisitTracker;
